
import React from 'react';
import AddMenu from './AddMenu';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.addMenu);

  let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

  if (!isStoreAuthenticated) {
    return { redirect: '/store/login' };
  };

  return {
    title,
    component: (
      <DashboardLayout>
        <AddMenu title={title} />
      </DashboardLayout>
    ),
  };
}

export default action;
